
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexIUioTbhRCQJ1vr7IgQUeAAIQIowQwoZFb2rmlXatO3UMeta } from "/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/index.vue?macro=true";
import { default as login9wzMfvlrtMkdcEfVBoyZfptLwmmDnCqpBg0ePuEDrtkMeta } from "/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/login.vue?macro=true";
import { default as issuesYaATwNfFTqv_z6NG_45AysEeANAcRdobpvOnfpAAvqcGEMeta } from "/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/issues.vue?macro=true";
import { default as categoriescjFLKBm2ZZPgaOLrhONBcldjDf29vUpDPfKvgT46hP0Meta } from "/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/categories.vue?macro=true";
import { default as rolesEXmh5X_452owXciYPyWjckGFhQtU_TvaoFlhOcBYnRR18Meta } from "/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/admin/roles.vue?macro=true";
import { default as usersO84R2oRn9Y_45YkA_EFdKxIsq2qkiFG_453taO_XVd6g3yQMeta } from "/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/admin/users.vue?macro=true";
import { default as notificationSettingsO1hwQdU7A_45T0fj1KdLPYeFzxtlCgE2Kmp83ahEDdPvgMeta } from "/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/notificationSettings.vue?macro=true";
import { default as permissions8SUWpZqbOBUTmJeh5diMg_WArVQ1th7UlbivPM_O5W0Meta } from "/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/admin/role/permissions.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexIUioTbhRCQJ1vr7IgQUeAAIQIowQwoZFb2rmlXatO3UMeta || {},
    component: () => import("/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: login9wzMfvlrtMkdcEfVBoyZfptLwmmDnCqpBg0ePuEDrtkMeta || {},
    component: () => import("/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/login.vue")
  },
  {
    name: "issues",
    path: "/issues",
    component: () => import("/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/issues.vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: categoriescjFLKBm2ZZPgaOLrhONBcldjDf29vUpDPfKvgT46hP0Meta || {},
    component: () => import("/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/categories.vue")
  },
  {
    name: "admin-roles",
    path: "/admin/roles",
    meta: rolesEXmh5X_452owXciYPyWjckGFhQtU_TvaoFlhOcBYnRR18Meta || {},
    component: () => import("/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/admin/roles.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: usersO84R2oRn9Y_45YkA_EFdKxIsq2qkiFG_453taO_XVd6g3yQMeta || {},
    component: () => import("/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/admin/users.vue")
  },
  {
    name: "notificationSettings",
    path: "/notificationSettings",
    meta: notificationSettingsO1hwQdU7A_45T0fj1KdLPYeFzxtlCgE2Kmp83ahEDdPvgMeta || {},
    component: () => import("/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/notificationSettings.vue")
  },
  {
    name: "admin-role-permissions",
    path: "/admin/role/permissions",
    meta: permissions8SUWpZqbOBUTmJeh5diMg_WArVQ1th7UlbivPM_O5W0Meta || {},
    component: () => import("/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/pages/admin/role/permissions.vue")
  }
]